<template>
    <div class="hp-newsletter">
        <div class="hp-newsletter__inner">
            <div class="content">
                <h3>Be Our Travel Buddy</h3>
                <p>
                    We send really fun emails about trending<br>destinations, travel tips and exclusive offers. <br>
                    Sign up so you don't miss a thing.
                </p>
            </div>
            <form class="newsletter-form" method="POST" @submit.prevent="submit($event)">
                <input type="text" v-model="form.email" name="newsletter_email" id="newsletter_email" placeholder="Enter Your Email">
                <button type="submit" :disabled="form.isSubmitted">
                    Subscribe <svg class='arrow-right-2'><use xlink:href="#arrow-right-2"></use></svg>
                </button>
                <div v-text="form.errors.email" class="error"></div>
            </form>
        </div>
    </div>
</template>
<script>

import Form from '@/classes/Form'
import Toast from '@/classes/Toast'

export default {

    data() {
        return {
            form: new Form({
                email: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post('/newsletter').then(response => {
                Toast.success(response.success)
            })
            .catch(errors => {
                // document.getElementById('msg-error').display = 'block'
                // Toast.error(response.success)
                // console.log(errors.message)
            })
        }
    }
}
</script>
